import { RoomTypeEntity, RoomTypeResponse } from 'src/types'

export const RoomTypeTranslator = {
  toEntity: (response: RoomTypeResponse): RoomTypeEntity => {
    return {
      id: `${response.id}`,
      name: response.name,
      priority: response.priority,
    }
  },

  toEntities: (responses: RoomTypeResponse[]): RoomTypeEntity[] => {
    return responses.map(response => RoomTypeTranslator.toEntity(response))
  },
} as const
